export const getLinkImageSrc = (link: string, clientCode: string) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  return `${baseUrl}Images/${clientCode}/${link}`;
};

export const getFileExtensionIfExists = (url: string) => {
  const fileNameStart = url.lastIndexOf("/");
  if (fileNameStart === -1) return;

  const fileName = url.slice(fileNameStart + 1);
  const extStart = fileName.indexOf(".");
  if (extStart === -1) return;

  const extEnd = fileName.search(/$|[?#]/);
  return `.${fileName.substring(extStart + 1, extEnd)}`;
};
